import Axios, { Response } from '../utils/Axios';

export type SectorType = {
  parent_store_sector_id: number;
  store_sector_id: number;
  depth: number;
  id_order: number;
  parent_sector_name: string | null;
  sector_name: string;
  sector_list: SectorType[];
  is_check: boolean;
};

const AdvertiseController = {
  // 업종 카테고리
  getSector: async (storeId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/3/${storeId}/getSector`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[업종 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setSector: async (store_id: number, sector_list: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setSector';
      const oParams = {
        store_id: store_id,
        sector_list: sector_list,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[업종 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 광고 이미지, 비디오
  getAdver: async (storeId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${storeId}/getAdver`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[광고 이미지, 비디오 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setAdver: async (store_id: number, video: any, image: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setAdver';
      const oParams = {
        store_id: store_id,
        adver: {
          video: video,
          image: image,
        },
      };
      console.log('oParams---------->',oParams)
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[광고 이미지, 비디오 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 광고 이미지, 비디오 업로드
  storeAdUploadImg: async (image: any, store_id: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/adver/upload`;
      const response: any = await Axios.multipartPost(sUrl, image, store_id, 'adver_img');
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[광고 이미지, 비디오 업로드 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default AdvertiseController;
